<template>

  <div class="ui padded grid">

    <nav-back-office-top></nav-back-office-top>


    <div class="sixteen wide column">

      <div class="ui left labeled fluid icon input">
        <div class="ui label">
          <i class="users icon"></i> Search for a Patient
        </div>
        <input type="text" placeholder="You can use Patient ID or Patient Name" v-model="filterPatientCriteria">
        <i class="search icon"></i>
      </div>

      <br>

      <table class="ui celled striped large table">
        <thead>
          <tr>
            <th class="fitted">Medgate ID</th>
            <th>Name</th>
            <th>Progress</th>
            <th>Last Feedback Date</th>
            <th>Telemedicine Doctor Appointment</th>
            <th>Telemedicine Nurse Appointment</th>
          </tr>
        </thead>
        <tbody>
        <tr v-for="patient in filteredPatientArray"
            v-if="patient.profile.data.hasOwnProperty('medgateId') && patient.profile.data.hasOwnProperty('startDate')">
          <td>
            <router-link :to="{ name: 'PagePatientDetails', params: { patientid: patient.id } }">
              {{ patient.profile.data.medgateId }} <i class="chevron right icon"></i>
            </router-link>
          </td>
          <td>{{ patient.profile.data.name }}</td>
          <td>
            <span v-if="patient.profile.data.startDate > currentTimestamp">Not yet started</span>
            <span v-else>Day {{ renderCurrentCoachingDay(patient.profile.data.startDate) }}</span>
          </td>
          <td>
            <span v-if="patient.profile.data.hasOwnProperty('coachMessage') && patient.profile.data.coachMessage.lastModifiedTime !== null">{{ localizedTimestamp(patient.profile.data.coachMessage.lastModifiedTime) }}</span>
            <span v-else>Not given</span>
          <td>
          <router-link :to="{ name: 'PagePatientDetails', params: { patientid: patient.id , tabId: 2}}" class="ui icon circular button">
              <i class="pencil icon">
              </i>
          </router-link>
            <span v-if="patient.profile.data.hasOwnProperty('docAppt') && patient.profile.data.docAppt.timestamp !== null">{{ localizedTimestamp(patient.profile.data.docAppt.timestamp, 'en-US', apptOptions ) }}</span>
            <span v-else>Not set</span>
            <i v-if="patient.profile.data.hasOwnProperty('docAppt') && patient.profile.data.docAppt.reschedule === true" class="red calendar times outline icon"></i>
          </td>
          <td>
            <router-link :to="{ name: 'PagePatientDetails', params: { patientid: patient.id , tabId: 2}}" class="ui icon circular button">
              <i class="pencil icon">
              </i>
            </router-link>
            <span v-if="patient.profile.data.hasOwnProperty('coachAppt') && patient.profile.data.coachAppt.timestamp !== null">{{ localizedTimestamp(patient.profile.data.coachAppt.timestamp, 'en-US', apptOptions ) }}</span>
            <span v-else>Not set</span>
            <i v-if="patient.profile.data.hasOwnProperty('coachAppt') && patient.profile.data.coachAppt.reschedule === true" class="red calendar times outline icon"></i>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import SearchPatients from './SearchPatients.vue'
  import NavBackOfficeTop from '../NavBackOfficeTop.vue'

  export default {
    components: { SearchPatients, NavBackOfficeTop },
    data () {
      return {
        currentTimestamp: new Date().getTime(),
        filterPatientCriteria: null,
        apptOptions: { timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true }
      }
    },
    computed: {
      ...mapState(['patientsAllOverview']),


      filteredPatientArray: function() {
        if (this.filterPatientCriteria === null || this.filterPatientCriteria.length === 0){
          return this.patientsAllOverview
        }
        else {
          let searchResultsbyPatientId;
          let searchResultsbyPatientName;

          //TODO: Fix this
          searchResultsbyPatientId = this.patientsAllOverview.filter(patient => patient.profile.data.medgateId !== null && patient.profile.data.medgateId.toString().includes(this.filterPatientCriteria) );
          searchResultsbyPatientName = this.patientsAllOverview.filter(patient =>
            (patient.profile.data.name !== null && patient.profile.data.name.toString().toLowerCase().includes(this.filterPatientCriteria.toLowerCase()) ) || (patient.profile.data.name !== null && patient.profile.data.name.toString().toLowerCase().includes(this.filterPatientCriteria.toLowerCase()) )

          );

          let searchResults = searchResultsbyPatientName > searchResultsbyPatientId ? searchResultsbyPatientName : searchResultsbyPatientId;
          return searchResults;
        }
      }
    },
    methods: {
      renderCurrentCoachingDay: function(timestamp){
        return Math.floor((this.currentTimestamp - timestamp) / 86400000) + 1
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/patients/TabPatient.vue